import React from "react";

import { ReactComponent as StarIcon } from "../../../assets/star.svg";
import { ReactComponent as StarDefaultIcon } from "../../../assets/star_active.svg";

import classes from "./Star.module.css";

const Star = (props: any) => {
  const Hover = ({ onHover, children }: { onHover: any; children: any }) => (
    <span className={classes.hover} onClick={props.onClick}>
      <div
        className={["align-middle", classes["hover__no-hover"]].join(" ")}
        style={{ margin: "0 12.5px" }}
      >
        {children}
      </div>
      <div
        className={["align-middle", classes["hover__hover"]].join(" ")}
        style={{ margin: "0 12.5px" }}
      >
        {onHover}
      </div>
    </span>
  );
  return (
    <>
      {props.active ? (
        <div
          className="d-inline-block align-middle"
          style={{ margin: "0 12.5px" }}
        >
          <StarDefaultIcon />
        </div>
      ) : (
        <Hover onHover={<StarDefaultIcon />}>
          <StarIcon />
        </Hover>
      )}
    </>
  );
};

export default Star;
